import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Login.css';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login } = useAuth();
  const navigate   = useNavigate();
  const location   = useLocation();
  const registered = location.state?.registered;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/admin');
    } catch {
      setError('Invalid username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-visual">
        <img
          src="https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&w=1200&q=80"
          alt=""
        />
        <div className="login-visual-overlay">
          <img className="login-visual-logo" src="/brand/logo-white.png" alt="Boom Creations" />
          <div className="login-visual-tag">Admin Dashboard</div>
        </div>
      </div>

      <div className="login-form-wrap">
        <div className="login-box">
          <h1 className="login-title">SIGN IN</h1>
          <p className="login-sub">Access the content management dashboard.</p>

          {registered && <div className="login-error" style={{ borderColor:'#50c878', background:'rgba(80,200,120,0.08)', color:'#50c878' }}>Account created — sign in below.</div>}
          {error && <div className="login-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                placeholder="admin"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="login-field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </div>
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          <Link to="/" className="login-back">← Back to Website</Link>
          <Link to="/admin/register" className="login-back" style={{ marginTop: '0.5rem' }}>No account? Create one →</Link>
        </div>
      </div>
    </div>
  );
}
